import { styled } from '@linaria/react';
import { layout, semantic, size, space } from '../../theme/tokens';

export const Bar = styled.div`
  flex-shrink: 0;
  position: fixed;
  bottom: var(--sticky-footer-offset-bottom, ${layout.mobileNavHeight});
  left: 0;
  right: 0;
  padding: ${space['space-300']} ${space['space-500']};
  background: ${semantic.bg.canvas};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  z-index: 103;

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: static;
    bottom: auto;
    padding: 0;
    padding-top: ${space['space-600']};
    background: none;
    border-top: none;
    z-index: auto;
  }
`;
